"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Apachesolr = function Apachesolr(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.74 3.797L8.919 16.585l14.866-6.842a11.695 11.695 0 0 0-3.045-5.946zM11.964 0a11.7 11.7 0 0 0-4.621.931L5.767 14.293 13.683.144C13.146.036 12.573 0 11.964 0zm11.929 10.46L9.815 18.34l13.218-1.576c.609-1.468.967-3.045.967-4.728 0-.537-.036-1.075-.107-1.576zm-5.194 11.534a12.403 12.403 0 0 0 3.797-4.155l-12.358 2.436 8.561 1.719zM14.436.251L7.558 15.188 20.346 3.367c-1.647-1.54-3.653-2.651-5.91-3.116zM13.003 24a11.838 11.838 0 0 0 3.761-.931l-6.949-.824L13.003 24zm-12-16.907A11.626 11.626 0 0 0 0 10.961l1.863 3.331-.86-7.199zm5.301-5.696a11.957 11.957 0 0 0-4.226 3.797l1.755 8.776L6.304 1.397z"
  }));
};

Apachesolr.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Apachesolr.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Apachesolr;
exports["default"] = _default;